import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { debounce, globalEventsHandler } from "@jti/fe-common";
import { useOutsideClick } from "@jti/ui";
import { useCartMiniContext } from "../../../../contexts/CartMiniContext";
import getElementHeightWithMargins from "../../../../utils/getElementHeightWithMargins";
import { CartMiniCheckoutButton } from "../../components/CartMiniCheckoutButton";
import { CartMiniContent } from "../../components/CartMiniContent";
import { CartMiniHeader } from "../../components/CartMiniHeader";
import { calculatFrameHeight } from "../../utils/calculatFrameHeight";
import { CartIcon } from "./CartIcon";
import styles from "./CartMiniContentContainer.module.scss";
export const CartMiniContentContainer = ({ itemsPending: pending = false, qtyPending = false, subtotal, items, opened, onOpen, onClose, itemsCount, onRemoveItemClick, onItemQuantityChange, onCheckoutClick, onRemoveItems, warningStatus, isLimitEnabled, isOnCartPage, }) => {
    const miniCartRef = useRef(null);
    const miniCartHeaderRef = useRef(null);
    const buyLimitation = !!(warningStatus && isLimitEnabled);
    const [fullScreenMinicart, setFullScreenMinicart] = useState(false);
    const [customStyles, setCustomStyles] = useState({});
    const { isDarkTheme } = useCartMiniContext();
    const classes = classNames(styles.miniCart, {
        [styles["miniCart--open"]]: opened,
        [styles["miniCart--with-items"]]: items?.length > 0,
        [styles["miniCart--no-items"]]: !(items?.length > 0),
        [styles["miniCart--fullscreen"]]: fullScreenMinicart,
        [styles["miniCart--dark"]]: isDarkTheme,
    });
    useEffect(() => {
        globalEventsHandler.getCartActive().dispatch({
            active: (opened || isOnCartPage) && !pending,
        });
    }, [opened, isOnCartPage, pending]);
    const onClickLabel = () => {
        if (!pending) {
            if (!opened && onOpen) {
                onOpen();
            }
            else if (onClose && opened) {
                onClose();
            }
        }
    };
    useOutsideClick(miniCartRef, () => {
        if (onClose) {
            onClose();
        }
    });
    const handleFullScreenMinicart = () => {
        const height = getElementHeightWithMargins(miniCartHeaderRef);
        setFullScreenMinicart(height > window.innerHeight);
    };
    useEffect(() => {
        if (opened && !pending) {
            handleFullScreenMinicart();
        }
        else {
            setFullScreenMinicart(false);
        }
    }, [opened, pending]);
    useEffect(() => {
        const updateFrameHeight = () => {
            setCustomStyles(calculatFrameHeight(miniCartRef));
        };
        const handleResize = () => {
            updateFrameHeight();
            handleFullScreenMinicart();
        };
        const handleResizeDebounced = () => debounce(handleResize, 250);
        handleResize();
        window.addEventListener("resize", handleResizeDebounced);
        return () => window.removeEventListener("resize", handleResizeDebounced);
    }, []);
    useEffect(() => {
        const onClickEscape = (e) => {
            if (e.key === "Escape" && onClose) {
                onClose();
            }
        };
        window.document.addEventListener("keydown", onClickEscape);
        return () => window.document.removeEventListener("keydown", onClickEscape);
    }, []);
    return (_jsxs("div", { className: styles.container, ref: miniCartRef, "data-testid": "cart", children: [_jsx(CartIcon, { disabled: pending, onClick: onClickLabel, label: itemsCount > 0 ? itemsCount : undefined, isOpen: opened || isOnCartPage }), _jsx("div", { className: classes, "data-js-selector": "mini-cart-content", "data-testid": "mini-cart-header", ref: miniCartHeaderRef, children: _jsxs("div", { className: styles.miniCartContainer, style: customStyles, children: [_jsx(CartMiniHeader, { subtotal: subtotal, itemsCount: itemsCount, onClose: onClose }), _jsx(CartMiniContent, { pending: pending, items: items, qtyPending: qtyPending, buyLimitation: buyLimitation, onRemoveItemClick: onRemoveItemClick, onItemQuantityChange: onItemQuantityChange, onRemoveItems: onRemoveItems }), _jsx(CartMiniCheckoutButton, { qtyPending: qtyPending, isVisible: items?.length > 0, buyLimitation: buyLimitation, onCheckoutClick: onCheckoutClick })] }) })] }));
};
//# sourceMappingURL=CartMiniContentContainer.js.map